export default __webpack_public_path__ + "static/media/team.290090a9.png";